module.exports = __webpack_public_path__ + "static/img/news10_17.ac99af9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/news10_17.png
// module id = Bi/X
// module chunks = 0